import { Stack } from "@mui/material";
import { DynamicCatalogBuilder } from "../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder";
import { pOItemsPagingAPI } from "../services/apiCalls";
import { PurchaseOrderKeys } from "../services/entity";
export var ItemsSectionGrid = function (props) {
    var PO_ID = props.PO_ID;
    return /*#__PURE__*/ React.createElement(Stack, {
        maxHeight: '340px'
    }, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        getPagingData: pOItemsPagingAPI,
        pagingAPIKey: PurchaseOrderKeys.ItemsPaging,
        pagingAPIRequest: {
            PurchaseOrderId: PO_ID
        },
        dataGridProps: {
            hideFooter: true
        }
    }));
};
